import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthGuard } from '@next/core-lib/authorization';

import { NutrientPropertiesComponent } from './nutrient-properties.component';

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forChild([
      {
        path: 'nutrient-properties',
        component: NutrientPropertiesComponent,
        canActivate: [AuthGuard],
      },
    ]),
  ],
})
export class NutrientPropertiesRoutingModule {}
